import { render, staticRenderFns } from "./IconsFile.vue?vue&type=template&id=6b98da71&scoped=true&"
import script from "./IconsFile.vue?vue&type=script&lang=js&"
export * from "./IconsFile.vue?vue&type=script&lang=js&"
import style0 from "./IconsFile.vue?vue&type=style&index=0&id=6b98da71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b98da71",
  null
  
)

export default component.exports